import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import WhatIsSection from "./components/WhatIsSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorks from "./components/HowItWorks";
import SafetySection from "./components/SafetySection";
import LatestGuides from "./components/LatestGuides";
import CTASection from "./components/CTASection";

const siteUrl = (typeof import.meta.env.VITE_SITE_URL === 'string' ? import.meta.env.VITE_SITE_URL : 'https://superbuyspread.quest').replace(/\/$/, '');

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Superbuy Spreadsheet",
  "alternateName": "Superbuy Spreadsheet Resource Hub",
  "url": siteUrl,
  "description": "The complete Superbuy Spreadsheet resource platform helping shoppers discover products, compare options, understand QC information, and make smarter purchasing decisions.",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteUrl}/?s={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const pageJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Superbuy Spreadsheet - The Ultimate Product Research & Shopping Guide",
  "description": "Discover the most complete Superbuy Spreadsheet guide with product categories, comparison tables, QC tips, safety information, and updated shopping resources. Your trusted resource for smarter product research.",
  "url": `${siteUrl}/`,
  "isPartOf": {
    "@type": "WebSite",
    "name": "Superbuy Spreadsheet",
    "url": siteUrl
  },
  "about": {
    "@type": "Thing",
    "name": "Superbuy Spreadsheet",
    "description": "A structured product research and organization system that transforms chaotic browsing into a streamlined, data-driven shopping experience."
  },
  "speakable": {
    "@type": "SpeakableSpecification",
    "xpath": ["/html/head/title"]
  }
};

const breadcrumbJsonLd = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": `${siteUrl}/`
    }
  ]
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Superbuy Spreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Superbuy Spreadsheet is a structured product research and organization system that transforms chaotic browsing into a streamlined, data-driven shopping experience. It covers 14 product categories including Shoes, Hoodies, T-Shirts, Jackets, Accessories, and more."
      }
    },
    {
      "@type": "Question",
      "name": "Is Superbuy Spreadsheet safe to use?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Superbuy Spreadsheet prioritizes user safety by emphasizing verified product sources, encouraging cross-referencing of product details, and providing comprehensive safety guidance for online shopping research."
      }
    },
    {
      "@type": "Question",
      "name": "How many product categories does Superbuy Spreadsheet cover?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Superbuy Spreadsheet covers 14 distinct product categories: Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear, Sets, Underwear and Underpants, Jerseys, Accessories, Bags, Belts, Perfumes, and Other Stuff."
      }
    },
    {
      "@type": "Question",
      "name": "Is Superbuy Spreadsheet free to use?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, Superbuy Spreadsheet provides free access to product category browsing, research tools, and comparison resources. Visit the main website to explore the full range of available products."
      }
    },
    {
      "@type": "Question",
      "name": "How does Superbuy Spreadsheet improve shopping decisions?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Superbuy Spreadsheet improves shopping decisions by providing organized product categories, side-by-side comparison capabilities, detailed product information, and a structured research methodology that leads to more confident purchasing decisions."
      }
    }
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <header>
        <Navbar />
      </header>
      <main>
        <article>
          <HeroSection />
          <CategoryGrid />
          <WhatIsSection />
          <FeaturesSection />
          <HowItWorks />
          <SafetySection />
          <LatestGuides />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}